/**
 * Error code to user-friendly message mapping for URL query parameter errors
 */
export const ERROR_MESSAGES: Record<string, string> = {
  EntraAuthenticationFailed: "Microsoft authentication failed. Please try again.",
  EntraConfigurationError: "Authentication configuration error. Please contact support.",
  EntraCancelled: "Microsoft authentication was cancelled.",
  EntraTimeout: "Authentication timed out. Please try again.",
  EntraLoginRequired: "This account requires Single Sign-On authentication.",
  InvalidToken: "Invalid authentication token. Please sign in again.",
  EntraAccountExists: "Your account is currently inactive. Please contact your administrator.",
  default: "An error occurred during sign-in. Please try again.",
};

/**
 * Flag to enable or disable automatic sign-in attempts globally
 */
export const ENABLE_AUTO_SIGN_IN = true;

/**
 * Duration to disable auto sign-in after a sign-out (in milliseconds)
 */
export const AUTO_LOGIN_DISABLE_DURATION = 5000; // 5 seconds

/**
 * localStorage key for disabling auto sign-in until user manually logs in
 */
export const DISABLE_AUTO_SIGNIN_KEY = "DisableAutoSignIn";

/**
 * localStorage key for temporarily disabling auto sign-in after sign-out
 */
export const AUTO_SIGNIN_DISABLED_TIME_KEY = "AutoSignInDisabledTime";

/**
 * localStorage key for tracking if an auto sign-in attempt is in progress
 */
export const AUTO_SIGNIN_ATTEMPT_IN_PROGRESS_KEY = "AutoSignInAttemptInProgress";

/**
 * localStorage key for storing the tenant ID for SSO
 */
export const TENANT_ID_KEY = "TenantID";
